// Generated for @nava/participant-copy: Clair's default texts in Danish. Edit the texts here; the
// participant app's locale files are not read at runtime.
/** Clair's default texts in Danish. The texts that changed for Clair are translated without native review yet. */
export const PARTICIPANT_COPY_DA = {
    'landing.changeLanguage': 'Skift sprog',
    'common.language': 'Sprog',
    // New for Clair, translated without native review yet.
    'common.talkInLanguages': 'Du kan tale med Clair på mere end 80 sprog.',
    'common.seeLanguages': 'Se hvilke',
    'footer.poweredBy': 'Leveret af',
    'landing.heading': 'Du er inviteret til en kort samtale.',
    'landing.intro': '{company} vil gerne høre, hvordan det går for dig. Du taler med Clair, en AI-assistent, når det passer dig.',
    'landing.continue': 'Fortsæt',
    'preflight.title': 'Vi har bare brug for et par ting',
    'preflight.checkInSubtitle': 'Gennemgå listen nedenfor for at starte samtalen.',
    'preflight.actions.expandItem': 'Udvid {{item}}',
    'preflight.microphone.title': 'Mikrofon adgang',
    'preflight.microphone.checkInPrivacy': 'Din stemme bruges til samtalen med Clair, en AI-assistent. Samtalen optages, transskriberes og deles med {company}. Alle data krypteres og opbevares sikkert.',
    'preflight.microphone.readMore': 'Læs mere',
    'preflight.microphone.grantAccess': 'Giv adgang',
    'preflight.microphone.indicatorAction': 'Giv adgang til mikrofonen',
    'preflight.microphone.accessGranted': 'Adgang givet',
    'preflight.microphone.errorHelper': 'Tjek dine browserindstillinger og prøv igen.',
    'preflight.microphone.browserNotSupported': 'Din browser understøtter ikke lydoptagelse. Brug venligst Chrome, Firefox eller Safari.',
    'preflight.terms.title': 'Privatliv & samtykke',
    'preflight.terms.checkInPrivacy': 'Samtalen føres af Clair, en AI-assistent, på vegne af {company}. Dine svar deles med {company} og bruges aldrig til reklame. Du kan stoppe når som helst.',
    'preflight.terms.readMore': 'Læs mere',
    'preflight.terms.accept': 'Ja, jeg accepterer',
    'preflight.terms.indicatorAction': 'Accepter privatliv og samtykke',
    'preflight.terms.accepted': 'Accepteret',
    'preflight.terms.rememberConsent': 'Husk mit samtykke i 30 dage',
    'preflight.terms.rememberConsentCallTooltip': 'Samtykket gemmes kun for denne samtale i denne browser i 30 dage.',
    'quickStart.agree': 'Accepter',
    'quickStart.back': 'Tilbage',
    'quickStart.cancel': 'Annuller',
    'preflight.startCheckIn': 'Start samtalen',
    'preflight.preparingCheckIn': 'Samtalen forberedes...',
    'preflight.preparingCheckInDelayedTitle': 'Samtalen forberedes.',
    'preflight.preparingCheckInDelayedSubtitle': 'Arbejder stadig, vent venligst.',
    'preflight.preparingCheckInLongSubtitleLineOne': 'Dette tager længere end forventet.',
    'preflight.preparingCheckInLongSubtitleLineTwo': 'Vær tålmodig.',
    'preflight.checkInPreparationFailedTitle': 'Samtalen kunne ikke forberedes',
    'preflight.checkInPreparationFailedMessage': 'Nogle filer til samtalen kunne ikke indlæses. Tjek din forbindelse, og prøv igen.',
    'preflight.retryPreparation': 'Try again',
    'interview.status.connecting': 'Forbinder',
    'interview.status.speaking': 'Taler',
    'interview.status.listening': 'Lytter',
    'interview.status.thinking': 'Tænker',
    'interview.question': 'Spørgsmål {{current}} af {{total}}',
    'interview.mainQuestion': 'Hovedspørgsmål {{current}} af {{total}}',
    'interview.recording': 'Dit svar optages...',
    'interview.endInterview': 'Afslut samtalen',
    'interview.muteTooltip': 'Slå mikrofon fra',
    'interview.unmuteTooltip': 'Slå mikrofon til',
    'interview.pauseTooltip': 'Tag en pause',
    'interview.resumeTooltip': 'Genoptag samtalen',
    'interview.subtitleTooltip.show': 'Vis undertekster (CC)',
    'interview.subtitleTooltip.hide': 'Skjul undertekster (CC)',
    'interview.toggleChat': 'Skriv i stedet',
    'interview.toggleVoice': 'Tal i stedet',
    'interview.chatTooltip.type': 'Skriv dit svar i stedet',
    'interview.chatTooltip.speak': 'Tal dit svar i stedet',
    'interview.chatTooltip.unavailable': 'Tilgængelig når forbindelsen er klar',
    'interview.chatDiscoveryHint': 'Kan du ikke tale? Tryk for at skrive i stedet',
    'interview.chatPlaceholder': 'Skriv din besked...',
    'interview.sendMessage': 'Send',
    'interview.chat.warmHeader': 'Tag dig god tid, jeg venter, mens du skriver',
    'interview.chat.newlineHint': 'Shift + Enter for ny linje',
    'interview.chat.aiVoiceOn': 'Stemme til',
    'interview.chat.aiVoiceOff': 'Stemme fra',
    'interview.chat.backToVoice': 'Tilbage til stemme',
    'interview.audio.controls': 'Lydindstillinger',
    'interview.audio.callVolume': 'Opkaldslydstyrke',
    'interview.audio.muteSpeaker': 'Slå højttaleren fra',
    'interview.audio.unmuteSpeaker': 'Slå højttaleren til',
    'interview.audio.microphone': 'Mikrofon',
    'interview.audio.speaker': 'Højttaler',
    'interview.audio.device': 'Lydenhed',
    'interview.audio.linkedRouting': 'Din telefon styrer mikrofonen og højttaleren sammen.',
    'interview.audio.phoneSpeaker': 'Telefonens højttaler',
    'interview.audio.phoneEarpiece': 'Telefonens øresnegl',
    'interview.audio.bluetoothHeadset': 'Bluetooth-headset',
    'interview.audio.wiredHeadset': 'Headset med ledning',
    'interview.audio.usbAudio': 'USB-lyd',
    'interview.audio.systemDefault': 'Systemstandard',
    'interview.audio.changeFailed': 'Lydenheden kunne ikke skiftes.',
    'interview.networkQuality.excellent': 'Netværkskvaliteten er fremragende.',
    'interview.networkQuality.good': 'Netværkskvaliteten er god.',
    'interview.networkQuality.poor': 'Netværkskvaliteten er dårlig.',
    'interview.networkQuality.bad': 'Netværkskvaliteten er meget dårlig.',
    'interview.networkQuality.offline': 'Forbindelsen er offline.',
    'interview.pauseModal.title': 'Samtalen er sat på pause',
    'interview.pauseModal.timeRemaining': '{{time}} tilbage',
    'interview.pauseModal.timeoutWarning': 'Hvis du bliver på pause, slutter samtalen snart af sig selv.',
    'interview.pauseModal.resume': 'Genoptag samtalen',
    'interview.pauseModal.end': 'Afslut samtalen',
    'interview.endConfirm.title': 'Afslut samtalen?',
    'interview.endConfirm.body': 'Du kan ikke vende tilbage efter at have afsluttet. Dine svar indtil nu gemmes.',
    'interview.endConfirm.cancel': 'Fortsæt samtalen',
    'interview.endConfirm.end': 'Afslut samtalen',
    'complete.checkInTitle': 'Tak for din tid',
    'complete.checkInMessage': 'Dine svar går til teamet hos {company}.',
    'studyClosed.checkInTitle': 'Denne samtale er lukket',
    'studyClosed.checkInMessage': 'Tak for din interesse, den tager ikke længere imod svar.',
    'studyNotOpen.checkInTitle': 'Denne samtale er ikke åben endnu',
    'studyNotOpen.checkInMessage': 'Prøv gerne linket igen senere.',
    'studyNotReady.checkInTitle': 'Samtalen er næsten klar',
    'studyNotReady.checkInMessage': 'Prøv gerne linket igen om et par minutter.',
    'participantLinkCompleted.checkInTitle': 'Du har allerede haft denne samtale',
    'participantLinkCompleted.checkInMessage': 'Tak for din tid, du behøver ikke at gøre mere.',
    'loading.interview': 'Indlæser samtalen...',
    'browserHelp.title': 'Åbn i din browser',
    'browserHelp.description': 'Appens indbyggede browser kan begrænse adgangen til mikrofonen. Åbn linket i {{browserOptions}} for at få den bedste oplevelse.',
    'browserHelp.namedDescription': 'Den indbyggede browser i {{app}} kan begrænse adgangen til mikrofonen. Åbn linket i {{browserOptions}} for at få den bedste oplevelse.',
    'browserHelp.appleBrowsers': 'Safari eller Chrome',
    'browserHelp.windowsBrowsers': 'Microsoft Edge eller Chrome',
    'browserHelp.otherBrowsers': 'Chrome eller en anden browser',
    'browserHelp.openSafari': 'Åbn i Safari',
    'browserHelp.copyLink': 'Kopiér link',
    'browserHelp.copied': 'Linket er kopieret. Indsæt det i din browser.',
    'browserHelp.manualCopy': 'Linket kunne ikke kopieres automatisk. Markér og kopiér linket nedenfor.',
    'browserHelp.copyInstructions': 'Kopiér linket nedenfor, og indsæt det i en anden browser. Du kan også se efter en mulighed i appens menu for at åbne siden i din standardbrowser.',
    'browserHelp.linkLabel': 'Link til samtalen',
    'browserHelp.continueAnyway': 'Fortsæt alligevel',
    'preflight.microphone.recovery.denied': 'Adgang til mikrofonen blev nægtet.',
    'preflight.microphone.recovery.timedOut': 'Anmodningen om mikrofonadgang tog for lang tid. Se efter en tilladelsesanmodning i din browser, og prøv igen.',
    'preflight.microphone.recovery.notFound': 'Ingen mikrofon blev fundet. Tilslut en mikrofon, og prøv igen.',
    'preflight.microphone.recovery.notReadable': 'Mikrofonen kunne ikke åbnes. Luk andre apps, der bruger den, og prøv igen.',
    'preflight.microphone.recovery.failed': 'Vi kunne ikke få adgang til mikrofonen. Kontrollér mikrofonen, og prøv igen.',
    'preflight.microphone.recovery.retry': 'Prøv igen',
    'preflight.microphone.recovery.close': 'Luk',
    'preflight.microphone.recovery.helpTitle': 'Tillad mikrofonadgang',
    'preflight.microphone.recovery.helpDescription': 'Adgang til mikrofonen er stadig blokeret. Browseren kan have gemt dit tidligere valg og derfor undlade at spørge om tilladelse igen.',
    'preflight.microphone.recovery.safariMacSettings': 'Vælg Safari > Indstillinger > Websteder > Mikrofon i Safaris menulinje. Find dette websted på listen.',
    'preflight.microphone.recovery.chromiumSettings': 'Klik på ikonet for webstedsindstillinger til venstre for adresselinjen, og vælg Webstedsindstillinger > Mikrofon.',
    'preflight.microphone.recovery.siteSettings': 'Åbn tilladelserne for dette websted via ikonet eller menuen ved adresselinjen eller via browserens webstedsindstillinger.',
    'preflight.microphone.recovery.allowMicrophone': 'Tillad mikrofonadgang for dette websted, vend tilbage hertil, og vælg “Prøv igen”. Genindlæs siden, hvis browseren beder dig om det.',
    'preflight.microphone.recovery.deviceSettings': 'Hvis adgang allerede er tilladt, skal du kontrollere, at enhedens indstillinger tillader browseren at bruge mikrofonen.',
    'microphoneQuality.title': 'Mikrofonkvalitet',
    'microphoneQuality.instructions': 'Tal i et par sekunder, så vi kan tjekke, hvor godt vi kan høre dig.',
    'microphoneQuality.recoveryMessage': 'Vi kan ikke høre dig. Hvis du er i et opkald, skal du afslutte det først. Luk andre apps, der bruger din mikrofon, og prøv igen.',
    'microphoneQuality.poor': 'Dårlig',
    'microphoneQuality.almostThere': 'Næsten der',
    'microphoneQuality.perfect': 'Perfekt!',
    'microphoneQuality.waiting': 'Venter på lyd...',
    'microphoneQuality.from': 'Fra',
    'microphoneQuality.defaultDevice': 'Standardmikrofon',
    'microphoneQuality.helpText': 'Tal venligst højere eller flyt dig tættere på mikrofonen',
    'microphoneQuality.done': 'Færdig',
    'startupRecovery.title': 'Samtalen kunne ikke starte',
    'startupRecovery.failed': 'Vi kunne ikke oprette forbindelse til samtaletjenesten. Prøv igen.',
    'startupRecovery.timedOut': 'Det tog for lang tid at oprette forbindelse. Prøv igen.',
    'startupRecovery.cancelled': 'Forbindelsen blev afbrudt. Du kan prøve igen, når du er klar.',
    'startupRecovery.microphone': 'Vi kunne ikke få adgang til din mikrofon. Tjek tilladelserne, og prøv igen.',
    'startupRecovery.delayed': 'Opretter stadig forbindelse. Det tager længere tid end normalt…',
    'startupRecovery.retry': 'Prøv igen',
    'startupRecovery.support': 'Supportreference',
    'startupRecovery.copy': 'Kopiér reference',
    'startupRecovery.copied': 'Kopieret',
    'startupRecovery.checking': 'Tjekker forbindelsen…',
    'startupRecovery.unavailable': 'Kunne ikke bekræftes',
    'startupRecovery.advice': 'Dette tjek viser kun, om tjenesterne kan nås. Du kan stadig prøve at starte. Hvis det ikke virker, kan du prøve en anden browser eller et andet netværk.',
    'startupRecovery.checkAgain': 'Kontrollér forbindelsen igen...',
    'connectionDetails.quality': 'Netværkskvalitet',
    'connectionDetails.excellent': 'Fremragende',
    'connectionDetails.good': 'God',
    'connectionDetails.poor': 'Svag',
    'connectionDetails.bad': 'Dårlig',
    'connectionDetails.offline': 'Offline',
    'connectionDetails.notChecked': 'Ikke tjekket',
    'connectionDetails.lastChecked': 'Sidst tjekket',
    'connectionDetails.warning': 'Forbindelsen til {{services}} kunne ikke bekræftes.',
    'connectionDetails.navaApi': 'Clairs API',
    'connectionDetails.interviewApi': 'Clairs samtaletjeneste',
    'connectionDetails.ok': 'OK',
    'connectionDetails.refresh': 'Opdater forbindelsestest',
    'connectionDetails.success': 'Forbindelsestjekket lykkedes.',
    'connection.error': 'Forbindelsesfejl',
    'connection.errorDefault': 'Kunne ikke oprette forbindelse til samtaletjenesten',
    'connection.retry': 'Prøv igen',
    'versionRefresh.message': 'En ny version er tilgængelig. Opdater din browser, når det passer dig.',
    'versionRefresh.action': 'Opdater',
    'cookies.banner.title': 'Vi værner om dit privatliv',
    'cookies.banner.message': 'Vi bruger cookies til at optimere din oplevelse, forstå produktbrug og understøtte relevant markedsføring. Vælg <bold>“Accepter alle”</bold> for at give samtykke til alle cookies, eller <bold>“Administrer præferencer”</bold> for at justere dine indstillinger.',
    'cookies.banner.privacyPolicy': 'Privatlivspolitik',
    'cookies.banner.acceptAll': 'Accepter alle',
    'cookies.banner.managePreferences': 'Administrer præferencer',
    'cookies.modal.title': 'Cookieindstillinger',
    'cookies.modal.description': 'Når du besøger Clair, kan vi gemme eller hente data om dig ved hjælp af cookies og lignende teknologier. Nødvendige cookies holder hjemmesiden kørende. Du kan til enhver tid ændre dine valgfrie præferencer.',
    'cookies.modal.readMore': 'Læs mere i vores',
    'cookies.modal.save': 'Gem',
    'cookies.modal.close': 'Luk cookie-indstillinger',
    'cookies.modal.essential.title': 'Nødvendige',
    'cookies.modal.essential.description': 'Kræves for grundlæggende webstedsfunktionalitet. Nødvendige cookies kan ikke deaktiveres.',
    'cookies.modal.analytics.title': 'Analyse',
    'cookies.modal.analytics.description': 'Hjælper Clair med at forstå, hvordan hjemmesiden fungerer, hvordan besøgende bruger den, og om der kan være tekniske problemer.',
    'invitation.subject': 'En kort samtale med {company}',
    'invitation.greeting': 'Hej {name},',
    'invitation.body': 'Vi vil gerne høre, hvordan det går for dig.',
    'invitation.aiNotice': 'Du taler med Clair, vores AI-assistent. De fleste synes, det er lettere at være ærlig over for en AI end over for et menneske, og du kan gøre det, når det passer dig, på arbejdet eller derhjemme.',
    'invitation.button': 'Start samtalen',
    'invitation.fallbackLink': 'Eller indsæt dette link i din browser:',
    'invitation.footer': 'Du får denne mail, fordi du er kunde hos {company}. Samtalen føres af Clair, en AI-assistent, på deres vegne.',
    'invitation.optOut': 'Send ikke dette til mig igen',
    'sms.invite': '{company} inviterer dig til en kort samtale:',
    'sms.stop': 'Afmeld SMS:',
};
//# sourceMappingURL=da.js.map